import axios from 'axios';
// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  async getTransaksiPage({ commit }, params) {
    try {
      const response = await axios.get(
        'procurement/getProcurements?pagenumber=' +
          params.page +
          '&namaproject=' +
          params.namaProject
      );

      commit('GET_TRANSAKSI_PAGE', response.data.data.items);
      commit('GET_TOTAL_DATA', response.data.data.total);

      return response;
    } catch (e) {
      return e;
    }
  },
  async uploadTransaksi({ commit }, params) {
    try {
      const response = await axios.post('procurement/import', params.data);

      return response;
    } catch (e) {
      return e;
    }
  },
  async uploadTransaksiNew({ commit }, params) {
    try {
      const response = await axios.post('procurement/importnew', params.data);

      return response;
    } catch (e) {
      return e;
    }
  },
};
